import * as React from 'react';
import { getPropsectForTour } from '../../../../../api/MyTours';
import { useFetch } from '../../../../../hooks/useFetch';
import FormValidationDisplay from '../../../../common/form/ValidationDisplay';
import { LoadingDisplay } from '../../../../common/LoadingOverlay';
import { TourSignedUpProps } from '../TourRouter';
import SignupSuccessfulSubpage from './SignupSuccessfulSubpage';

const SignupSuccessfulPage = (props: TourSignedUpProps) => {
    const { data, loading, error } = useFetch(
        () => getPropsectForTour(props.match.params.tourGuid),
        [],
        undefined
    );

    if (loading) {
        return <LoadingDisplay />;
    }

    if (data) {
        return <SignupSuccessfulSubpage prospect={data} />;
    }

    return <FormValidationDisplay errorMessage={error || 'No matching tour found'} />;
};

export default SignupSuccessfulPage;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/signup/confirmation/SignupSuccessfulPage.tsx